import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const providerBookButtonFormValidation = yupResolver(
  yup.object({
    email: yup
      .string()
      .trim()
      .email('Email is invalid')
      .required('Please enter your email'),
    timeSlot: yup
      .date()
      .required('Please choose a time for your appointment booking')
  })
)
